import { Injectable } from '@angular/core';
import { CitySearchItemResponse, CitySearchResponse, CitySearchSuggestion } from '@city/const';
import { CityActions, OccCitySearchService } from '@city/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class CitySearchEffects {
  loadCitySearch$: Observable<CityActions.CitySearchSuccess | CityActions.CitySearchFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.CITY_SEARCH_LOAD),
      distinctUntilChanged(),
      debounceTime(700),
      map((action: CityActions.CitySearch) => action.payload),
      mergeMap((query: string) => {
        return this.citySearchFacade.loadSuggestions(query).pipe(
          map<CitySearchResponse, CitySearchSuggestion[]>(({ data }: CitySearchResponse) =>
            data.items.map(({ id, coords, name, region, short_type, type }: CitySearchItemResponse) => ({
              id,
              name,
              region,
              shortType: short_type,
              type,
              geoPoint: {
                latitude: coords.lat,
                longitude: coords.lon,
              },
              nameWithShortType: `${short_type}. ${name}`,
              label: `${short_type}. ${name}, ${region}`,
            })),
          ),
          map((suggestions: CitySearchSuggestion[]) => new CityActions.CitySearchSuccess(suggestions)),
          catchError((error: unknown) => of(new CityActions.CitySearchFail(error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private citySearchFacade: OccCitySearchService,
  ) {}
}
